import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiTranscriptionDeliveryModesFetchFailedAction = {
	type: 'AI_TRANSCRIPTION_DELIVERY_MODES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiTranscriptionDeliveryModesFetchFailedAction => ({
	type: 'AI_TRANSCRIPTION_DELIVERY_MODES_FETCH_FAILED',
	payload,
});
